<template>
  <div>
    <div style="background:#f4f4f4; border-top:2px solid #ddd;">
      <div class="widM padTS padBS">
        <div class="fntH4 bold padBSM" style="color:#2c2c2c;">참가자 정보</div>
        <p class="fntE colorGray">- * 표시는 필수 입력사항입니다.</p>
        <p class="fntE colorGray">- 첨부파일은 JPG, PNG, PDF 형식으로 최대 10MB까지 등록하실 수 있습니다.</p>
      </div>
    </div>
    
    <div class="widM NCACroa_cont01_wrap">
      <div class="clearfix" v-if="responses">
        <template v-for="(response, idx) in responses">
          <SurveyParticipant
            :key="`response${idx}`"
            :seq="idx"
            :participant="response"
            :has-family="hasFamily"
          />
          <hr
            v-if="idx < responses.length - 1"
            :key="`hr${idx}`"
            class="moOnly"
            style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SurveyParticipant from './SurveyParticipant.vue'
import { SURVEY } from '@/store/actions/survey'
import { mapState } from 'vuex'
import { CommonMethodMixin } from '../mixins'

export default {
  name: 'SurveyParticipantInfo',
  mixins: [CommonMethodMixin],
  components: {
    SurveyParticipant
  },
  computed: {
    ...mapState(SURVEY, {
      responses: state => state.responses,
      mode: state => state.mode,
    }),
    hasFamily() {
      return this.responses && !!this.responses.find(response => response.type === 'S' || response.type === 'F');
    }
  },
  methods: {
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey/components/SurveyParticipantInfo.vue